import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
const BACKEND_URL = (process.env.REACT_APP_BACKEND_PUBLIC_BASE_URL || 'http://localhost:5000').replace(/\/api\/?$/, '');
const bootstrap = async () => {
  try {
    const res = await fetch(`${BACKEND_URL}/site-settings.json`);
    if (res.ok) window.__SITE_SETTINGS__ = await res.json();
  } catch {}

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  reportWebVitals();
};

bootstrap();
